module.exports = __webpack_public_path__ + "zarustajici-nehty_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/zarustajici-nehty_4_after.jpg
// module id = 1043
// module chunks = 0